// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { CFreeText_abstract } from './../abstract/SagaSchema/CFreeText_abstract';
export class CFreeText extends CFreeText_abstract {}
